import React, { useState, useEffect } from "react";
import { SEC_DataApiPost } from "../../func.js";
import "./SelectUserComponent.css";
import Select from 'react-select';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export function SelectUserComponent({ id, url, usersArray, updateApiCallFunction, setActiveOption }) {
  const [selectedUser, setSelectedUser] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [postApiErrorState, setPostApiErrorState] = useState(false);

  async function assignUser(selectInput) {
    if (isLoading) return; // Prevent multiple clicks

    setIsLoading(true);
    setPostApiErrorState(false);
    
    let cogId = selectInput['cogId'];
    setSelectedUser(selectInput);
    let formData = { "requestId": id, "cogId": cogId };

    try {
      const response = await SEC_DataApiPost(url, formData, formData, () => setPostApiErrorState(true));
      if (response && response.ResponseMetadata.HTTPStatusCode === 200) {
        toast.success("✅ Request assigned!", { autoClose: 3000, position: "top-right" });
        updateApiCallFunction(id);
        setIsLoading(false);
        setSelectedUser('');
        setActiveOption(null);  // ✅ Closes the dropdown
      } else {
        toast.error("❌ Failed to assign user. Please try again.", { autoClose: 3000, position: "top-right" });
        setIsLoading(false);
        setSelectedUser('');
      }
    } catch (e) {
      console.log(e);
      toast.error("⚠️ An error occurred while processing the request.", { autoClose: 3000, position: "top-right" });
      setPostApiErrorState(true);
      setIsLoading(false);
      setSelectedUser('');
    } finally {
      setIsLoading(false);
      setSelectedUser('');
    }
  }

  return (
    <div className="select-user-container">
      <Select
        className='toolbar-person-selector'
        maxMenuHeight={'200px'}
        value={selectedUser}
        getOptionLabel={option => option.displayName}
        getOptionValue={option => option.cogId}
        options={usersArray}
        isDisabled={isLoading}  
        styles={{
          control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "none",
            backgroundColor: isLoading ? "#e0e0e0" : "#ffffff",
            color: "#000000",
            width: "100%",
            cursor: isLoading ? "not-allowed" : "pointer",
          })
        }}
        placeholder={isLoading ? "Assigning user..." : "Select Person"}
        noOptionsMessage={() => 'Unable to find available IT staff'}
        onChange={assignUser}
      />
    </div>
  );
}
